import React from "react";

const Overview = () => {
  return (
    <div>
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8">

          <div className="card shadow-sm border-0">
            <div className="card-header bg-warning bg-opacity-25 border-0 py-4 text-center">
              <i className="bi bi-exclamation-triangle text-warning display-4"></i>
              <h3 className="mt-3 fw-bold text-warning">Please Read Before Continuing</h3>
            </div>

            <div className="card-body p-4">
              <p className="lead text-muted">
                You are about to modify communication templates used for sending
                <strong> SMS messages, emails, and automated phone calls</strong>.
              </p>

              <ul className="list-group list-group-flush my-4">
                <li className="list-group-item">
                  <i className="bi bi-exclamation-circle text-danger me-2"></i>
                  <strong>Changes will immediately impact all future outgoing communication.</strong>
                </li>
                <li className="list-group-item">
                  <i className="bi bi-x-circle text-danger me-2"></i>
                  <strong>Changes cannot be reverted</strong> — there is no version history.
                </li>
                <li className="list-group-item">
                  <i className="bi bi-person-lock text-primary me-2"></i>
                  Only authorized and responsible staff should make template changes.
                </li>
                <li className="list-group-item">
                  <i className="bi bi-clock-history text-secondary me-2"></i>
                  Updates <strong>may not take effect immediately</strong>, depending on system caching.
                </li>
                <li className="list-group-item">
                  <i className="bi bi-envelope-paper-heart text-success me-2"></i>
                  Changes will <strong>not affect previously sent messages or calls</strong>.
                </li>
              </ul>

              <p className="text-muted small">
                Please proceed only if you fully understand the impact of modifying communication templates.
              </p>

             
            </div>

          </div>

        </div>
      </div>
    </div>
    </div>
  );
};

export default Overview;